import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAccountDetailsParamsRawI,
	LWApiPublicAccountDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_DETAILS_QUERY_KEY = '/account/details';

const useAccountDetails = (
	params: LWApiPublicAccountDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicAccountDetailsResultRawI, ApiErrorI>,
) => {
	return useQuery({
		queryKey: [ACCOUNT_DETAILS_QUERY_KEY, params],
		queryFn: () => api.account.apiRaw.details(params),
		...options,
	});
};

export default useAccountDetails;
